// Saga to handle fetching tax document data.

import { takeLatest, put, call } from 'redux-saga/effects';
import { NetworkManager } from '../../api/NetworkManager';
import {
  getTaxDocumentListSuccess,
  getTaxDocumentListFailure,
  getTaxDocumentSuccess,
  getTaxDocumentFailure,
} from './action';
import {
  GET_TAX_DOCUMENT_LIST,
  GET_TAX_DOCUMENT,
} from './constant';

// Utility to convert Blob to base64
export function* blobToBase64(blob: Blob): any {
  return yield new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const result = reader.result as string;
      const base64Data = result.split(',')[1];
      resolve(base64Data);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

// Get Tax Document List API Saga.
export function* getTaxDocumentListData(action) {
  try {
    const response = yield call(NetworkManager.getTaxDocumentListData, action.payload.token);
    if (response?.data) {
      yield put(getTaxDocumentListSuccess(response.data));
    } else {
      yield put(getTaxDocumentListFailure({ message: 'No data returned' }));
    }
  } catch (error) {
    yield put(getTaxDocumentListFailure(error));
  }
}

// Get Tax Document API Saga will go here..
export function* getTaxDocumentData(action) {
  try {
    const { token, formId } = action.payload;
    const response = yield call(NetworkManager.getTaxDocument, token, formId);

    const base64String = response?.data?.['1099-TaxDocument']?.[0];

    if (!base64String) {
      yield put(getTaxDocumentFailure({ error: { message: 'Missing document content' } }));
      return;
    }

    const byteCharacters = atob(base64String);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      byteArrays.push(new Uint8Array(byteNumbers));
    }

    const blob = new Blob(byteArrays, { type: 'application/pdf' });

    yield put(getTaxDocumentSuccess({
      blob,
      formId,
      taxYear: '',
      taxLocation: '',
      distributionCode: '',
    }));

  } catch (error) {
    yield put(getTaxDocumentFailure({ error }));
  }
}

export function* watchTaxDocumentSaga() {
  yield takeLatest(GET_TAX_DOCUMENT_LIST, getTaxDocumentListData);
  // Get Tax Document API Saga yield will go here..
  yield takeLatest(GET_TAX_DOCUMENT, getTaxDocumentData);
}